<br>
  <div class="addMargin">
    <span class="headerText">Pesticide Application Records</span>
    <div style="float:right">
      <div class="addNewButton">
        <input name="customers" class="searchBar" [(ngModel)]="customers" type="text" pInputText (ngModelChange)="onFilterCustomers()" placeholder="Search Customers or Address">
        <p-button type="button" icon="pi pi-refresh" (click)="refreshPage()" severity="warn"
          class="marginCalendar">
        </p-button>
        <div class="marginCalendar">
          <p-datepicker name="filterDates" [(ngModel)]="filterDates" selectionMode="range" class="secondary"
            (ngModelChange)="onFilterDateChange()" placeholder="Filter by Date Range">
          </p-datepicker>
        </div>
        <p-button type="button" label="Add New" (click)="onAddNew()" severity="success"></p-button>
      </div>
    </div>
  </div>
<br/>
  <p-table showGridlines stripedRows responsiveLayout="stack" class="lessTablePad" [columns]="cols" [value]="records" [paginator]="true" [rows]="30" #table>
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [style.width]="col.width" class="ui-p-{{col.uiPriority}}">
            {{col.header}}
            @if (col.header != '') {
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record let-columns="columns" let-rowIndex="rowIndex">
      <tr>
        <td class="ui-p-{{ columns[0].uiPriority }}">{{record.dateApplied | date}}</td>
        <td class="ui-p-{{ columns[1].uiPriority }}">{{record.applicator.fullName}}</td>
        <td class="ui-p-{{ columns[2].uiPriority }}">{{record.certifiedApplicator.fullName}}</td>
        <td class="ui-p-{{ columns[3].uiPriority }}">{{record.chemical.displayName}}</td>
        <td class="ui-p-{{ columns[4].uiPriority }}">{{record.chemical.registrationNumber}}</td>
        <td class="ui-p-{{ columns[5].uiPriority }}">{{record.chemical.mixRate}}</td>
        <td class="ui-p-{{ columns[6].uiPriority }}">{{record.amountConcentrateUsed}}</td>
        <td class="ui-p-{{ columns[7].uiPriority }}">{{record.totalVolume}}</td>
        <td class="ui-p-{{ columns[8].uiPriority }}">{{record.chemicalApplicationMethod.method}}</td>
        <td class="ui-p-{{ columns[9].uiPriority }}">{{record.startTime | date:'shortTime':'-0400'}}</td>
        <td class="ui-p-{{ columns[10].uiPriority }}">{{record.endTime | date:'shortTime':'-0400'}}</td>
        <td class="ui-p-{{ columns[11].uiPriority }}">{{record.windDirectionAndSpeed}}</td>
        <td class="ui-p-{{ columns[12].uiPriority }}">{{record.temperature}}</td>
        <td class="ui-p-{{ columns[13].uiPriority }}">{{record.chemicalApplicationLocation.location}}</td>
        <td class="ui-p-{{ columns[14].uiPriority }}">{{record.customerName}}</td>
        <td class="ui-p-{{ columns[15].uiPriority }}">{{record.address}}</td>
        <td class="ui-p-{{ columns[16].uiPriority }}">{{record.quoteNumber}}</td>
        <td class="ui-p-{{ columns[17].uiPriority }}">
          <p-button [disabled]="!canEditAndDelete" type="button" icon="pi pi-pencil" (click)="editRecord(record)"
            severity="info" >
          </p-button>
          <p-button [disabled]="!canEditAndDelete" type="button" icon="pi pi-trash" (click)="deleteRecord(record)" severity="danger">
          </p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
